import {assert} from 'Asserts';

/**
 * Returns a new list with `item` moved from its current position in `list` to `newIndex`. Throws exception
 * if `item` does not appear exactly once in `list`.
 */
export function immutableMove<T>(list: Array<T>, item: T, newIndex: number): Array<T> {
  const itemCount = list.filter((i) => i === item).length;
  assert(
    itemCount === 1,
    `expected item to appear in the list exactly once, but it appears ${itemCount} times`
  );
  return immutableInsert(immutableRemove(list, item), newIndex, item);
}

/**
 * Returns a new list like `list` but with `item` inserted at `index`.
 */
export function immutableInsert<T>(list: Array<T>, index: number, item: T): Array<T> {
  return [...list.slice(0, index), item, ...list.slice(index)];
}

/**
 * Returns a new list like `list` but with the item at `index` replaced with `item`.
 */
export function immutableReplace<T>(list: Array<T>, index: number, item: T): Array<T> {
  return [...list.slice(0, index), item, ...list.slice(index + 1)];
}

/**
 * Returns a new list with all occurrences of `item` removed.
 */
export function immutableRemove<T>(list: Array<T>, item: T): Array<T> {
  return list.filter((elem) => elem !== item);
}

/**
 * Returns a new list with the item at `index` removed.
 */
export function immutableRemoveAt<T>(list: Array<T>, index: number): Array<T> {
  return [...list.slice(0, index), ...list.slice(index + 1)];
}
